// The booking wizard's wording in Russian; keys match en.ts.
import type { en } from "./en";

export const ru = {
  // Page
  schedule_appointment: "Записаться на приём",
  powered_by: "Работает на",

  // Patient type
  new_or_existing: "Вы новый или существующий пациент?",
  new_patient: "Новый пациент",
  existing_patient: "Существующий пациент",
  first_time_visiting: "Впервые в этом кабинете",
  been_here_before: "Я уже бывал(а) здесь",

  // Appointment info
  what_type: "Какой тип приёма?",
  no_types_available: "Сейчас нет типов приёмов, доступных для онлайн-записи.",
  minutes: "%{count} минут",
  additional_info: "Какую проблему или беспокойство вы хотели бы решить?",
  describe_concern: "Пожалуйста, опишите свою проблему...",

  // Provider
  pick_provider: "Выберите врача",
  loading_providers: "Загрузка врачей...",
  failed_load_providers: "Не удалось загрузить врачей. Попробуйте ещё раз.",
  any_provider: "Любой врач",
  show_all_available: "Показать все доступные часы",
  no_availability: "Нет свободных часов",

  // Time
  pick_a_time: "Выберите время",
  finding_times: "Ищем свободные часы...",
  no_times_for_date: "На эту дату нет свободных часов",
  slot_just_taken: "К сожалению, это время только что заняли. Пожалуйста, выберите другое.",
  jump_to_next: "К ближайшему свободному",
  morning: "Утро",
  afternoon: "День",
  cant_find_time: "Не находите удобное время? Позвоните нам, и мы поможем его подобрать.",

  // Patient info
  your_information: "Ваши данные",
  first_name: "Имя",
  last_name: "Фамилия",
  preferred_name: "Предпочитаемое имя",
  optional: "Необязательно",
  date_of_birth: "Дата рождения",
  phone_number: "Номер телефона",
  required: "Обязательно",
  invalid_phone: "Введите действительный 10-значный номер телефона",
  min_age: "Пациенту должно быть не менее 5 лет",
  future_date: "Не может быть в будущем",
  referral_question: "Откуда вы о нас узнали?",
  referral_prompt: "Выберите вариант",
  referral_detail_who: "Кто вас направил?",
  referral_detail_other: "Расскажите, как вы о нас узнали",
  referral_detail_optional: "Дополнительные сведения (необязательно)",
  verification_disclaimer: "На этот номер будет отправлен код подтверждения.",
  phone_verified: "Телефон подтверждён",
  verifying: "Проверка...",
  verify: "Подтвердить",
  invalid_code: "Недействительный код. Попробуйте ещё раз.",
  sending: "Отправка...",
  resend_code: "Отправить код ещё раз",
  email: "Электронная почта",
  send_verification: "Отправить код подтверждения",
  sending_code: "Отправка кода...",

  // Insurance
  insurance_info: "Информация о страховке",
  have_insurance: "Есть ли у вас страховка?",
  insurance_changed: "Изменилась ли ваша страховка с прошлого визита?",
  no_insurance_change: "Без изменений",
  yes: "Да",
  no: "Нет",
  insurance_name: "Название страховой",
  subscriber_name: "Имя застрахованного лица",
  subscriber_dob: "Дата рождения застрахованного лица",
  subscriber_id: "Идентификационный номер застрахованного лица",
  group_number: "Номер группы",
  select_option: "Пожалуйста, выберите вариант",
  card_photo_title: "Фото вашей страховой карты",
  card_photo_hint:
    "Добавьте фото обеих сторон карты, чтобы мы могли проверить вашу страховку до визита.",
  card_front: "Лицевая сторона карты",
  card_back: "Обратная сторона карты",
  add_photo: "Добавить фото",
  uploading_photo: "Загрузка фото...",
  remove_photo: "Удалить",
  card_upload_failed: "Не удалось добавить фото. Попробуйте ещё раз или продолжите без него.",
  card_try_again: "Попробовать ещё раз",

  // Review
  review_appointment: "Проверьте свой приём",
  appointment_details: "Детали приёма",
  type_label: "Тип",
  provider: "Врач",
  any_available: "Любой доступный",
  date_and_time: "Дата и время",
  notes: "Заметки",
  patient_information: "Информация о пациенте",
  name: "Имя",
  phone: "Телефон",
  insurance: "Страховка",
  subscriber: "Застрахованное лицо",
  subscriber_id_label: "ID застрахованного лица",
  group_hash: "№ группы",
  no_insurance: "Без страховки",
  card_photos: "Фото карты",
  card_front_short: "Лицевая сторона",
  card_back_short: "Обратная сторона",
  waitlist: "Свяжитесь со мной, если появятся более ранние часы",
  consent_prefix: "Записываясь, вы принимаете наши ",
  terms: "Условия использования",
  consent_and: " и ",
  privacy: "Политику конфиденциальности",
  consent_suffix:
    ". Указывая номер телефона, вы соглашаетесь получать текстовые сообщения. Может взиматься плата за сообщения и передачу данных.",
  scheduling: "Запись...",
  schedule_appointment_btn: "Записаться на приём",
  continue_to_payment: "Перейти к оплате",

  // Deposit
  deposit_title: "Оплатите депозит",
  deposit_explainer:
    "Депозит %{amount} подтверждает этот приём. Он будет зачислен на ваш счёт и применён к вашему приёму. Если вы не придёте на приём, вы потеряете депозит.",
  deposit_due: "Депозит",
  deposit_card_fee: "Комиссия за карту",
  deposit_card_fee_notice:
    "Платежи кредитной картой включают комиссию за обработку %{percentage}%. Дебетовые карты комиссией не облагаются.",
  deposit_total: "Итого",
  deposit_loading: "Загрузка безопасной оплаты...",
  deposit_paying: "Обработка...",
  deposit_pay_and_book: "Оплатить и записаться",
  deposit_card_error:
    "Не удалось принять ваш депозит. Проверьте данные карты и попробуйте ещё раз.",
  deposit_unavailable: "Не удалось загрузить безопасную оплату. Пожалуйста, позвоните в клинику.",
  deposit_needs_hold: "Не удалось забронировать это время. Пожалуйста, выберите время снова.",
  deposit_processing:
    "Ваш платёж всё ещё подтверждается. Не платите повторно — клиника скоро подтвердит ваш приём.",

  // Confirmation
  appointment_requested: "Мы получили ваш запрос на приём!",
  confirm_message:
    "Клиника рассмотрит его и отправит вам подтверждение. Если нам понадобится дополнительная информация, наша команда свяжется с вами.",
  date: "Дата",
  time: "Время",
  add_to_google: "Добавить в Google Календарь",
  download_ics: "Скачать файл календаря (.ics)",
  questions_call: "Есть вопросы? Позвоните нам:",

  // Errors
  network_error: "Что-то пошло не так. Пожалуйста, попробуйте ещё раз.",

  // Common
  back: "Назад",
  continue: "Продолжить",
  review: "Проверить",

  // Step labels
  step_appointment: "Приём",
  step_provider: "Врач",
  step_time: "Время",
  step_your_info: "Ваши данные",
  step_insurance: "Страховка",
} as const satisfies Record<keyof typeof en, string>;
